// Small pure formatters, shared across features. Unit-tested in format.test.ts.

const numberFmt = new Intl.NumberFormat('en-US');

export function formatInt(n: number): string {
  return numberFmt.format(Math.round(n));
}

export function formatUsd(n: number): string {
  return `$${n.toFixed(2)}`;
}

const PLATFORM_LABELS: Record<string, string> = {
  wordpress: 'WordPress',
  classicpress: 'ClassicPress',
};

export function formatPlatform(platform: string): string {
  return PLATFORM_LABELS[platform] ?? platform;
}

/**
 * True when a site/status should be treated as a LOCAL environment: either an
 * explicit `environment: 'local'` discriminator, or (fallback, no discriminator
 * populated yet) a `.local` domain/hostname.
 */
export function isLocalEnvironment(environment: string | undefined, domain: string | undefined): boolean {
  if (environment) return environment === 'local';
  return domain?.endsWith('.local') ?? false;
}

export type HealthFlagLabel = { text: string; tone: 'pass' | 'fail' | 'neutral' };

/**
 * JWT / PUC token / scanner checks don't apply to LOCAL environments (no JWT,
 * no PUC, no scanner locally) — render "N/A" (neutral) instead of a red "fail".
 * Production keeps the real pass/fail signal.
 */
export function healthFlagLabel(ok: boolean | null, isLocal: boolean): HealthFlagLabel {
  if (isLocal) return { text: 'n/a', tone: 'neutral' };
  // null = the site could not determine the flag (e.g. no EM_GITHUB_TOKEN to
  // probe for pucTokenOk). That is NOT a failure — rendering it as one sends
  // someone chasing an outage that does not exist.
  if (ok === null) return { text: 'unknown', tone: 'neutral' };
  return ok ? { text: 'ok', tone: 'pass' } : { text: 'fail', tone: 'fail' };
}
